import { createFileRoute } from "@tanstack/react-router";
import { MessageEditor } from "@/features/messages/MessageEditor";
function Page() {
  const { session } = Route.useRouteContext();
  return <MessageEditor key={session.user.id} actorId={session.user.id} />;
}
export const Route = createFileRoute(
  "/_authenticated/_protected/_admin/admin/messages",
)({ component: Page });
